module.exports = __webpack_public_path__ + "static/media/logo-dark.5be6bb5d.png";